/**
 * Drop-in replacement for next/navigation hooks.
 * After migration is stable, inline these into call sites and delete this file.
 */
import {
    useNavigate,
    useLocation,
    useSearchParams as useRRSearchParams,
    useParams as useRRParams,
} from 'react-router';
import {useMemo} from 'react';

export function useRouter() {
    const navigate = useNavigate();
    return useMemo(
        () => ({
            push: (path: string) => navigate(path),
            replace: (path: string) => navigate(path, {replace: true}),
            back: () => navigate(-1),
            refresh: () => window.location.reload(),
        }),
        [navigate]
    );
}

export function usePathname() {
    return useLocation().pathname;
}

export function useSearchParams() {
    const [searchParams] = useRRSearchParams();
    return searchParams;
}

export function useParams<
    T extends Record<string, string> = Record<string, string>,
>() {
    return useRRParams() as T;
}
